import { initialUserState } from '../state/InitialState'
import { UserState } from '../state/UserState'
import { UserReducerAction } from './UserReducerAction'
import { UserReducerType } from './UserReducerType'

export function userReducer(
  state: UserState,
  action: UserReducerAction,
): UserState {
  switch (action.type) {
    case UserReducerType.CLEAN_ALL_USERS: {
      return initialUserState
    }
    case UserReducerType.SET_ALL_USERS: {
      return { ...state, allUsers: action.payload }
    }
    case UserReducerType.SET_CREATE_USER: {
      return { ...state, createUser: action.payload }
    }
    case UserReducerType.SET_ALL_STUDENTS: {
      return { ...state, allStudents: action.payload }
    }
    case UserReducerType.SET_FILTERED_STUDENTS: {
      return { ...state, filteredStudents: action.payload }
    }
    case UserReducerType.SET_CURRENT_STUDENT: {
      return { ...state, currentStudent: action.payload }
    }
    case UserReducerType.SET_UPDATE_STUDENT: {
      return { ...state, updateStudent: action.payload }
    }
    case UserReducerType.SET_ALL_VEHICLE_LICENSES: {
      return { ...state, vehicleLicenses: action.payload }
    }
    case UserReducerType.SET_LICENSES: {
      return { ...state, licenses: action.payload }
    }
    case UserReducerType.SET_SELECTED_LICENSE: {
      return { ...state, selectedLicense: action.payload }
    }
    case UserReducerType.SET_CREATE_DEBT: {
      return { ...state, createDebt: action.payload }
    }
    case UserReducerType.SET_CREATE_PAYMENT: {
      return { ...state, createPayment: action.payload }
    }
    case UserReducerType.SET_EDIT_MODE: {
      return { ...state, editMode: action.payload }
    }
    case UserReducerType.SET_IS_VALID: {
      return { ...state, isValid: action.payload }
    }
    default:
      return initialUserState
  }
}
